import { render, staticRenderFns } from "./InventoryReports.vue?vue&type=template&id=6180f4b9&"
import script from "./InventoryReports.vue?vue&type=script&lang=js&"
export * from "./InventoryReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports